function errorHandler(title, status, toast) {
	const text = {
		400: 'درخواست معتبر نمی‌باشد',
		401: 'ابتدا وارد حساب کاربری خود شوید',
		404: 'یافت نشد',
		406: 'قابل قبول نمی‌باشد',
		500: 'خطایی رخ داده است',
		503: 'سرور درحال آماده‌سازی می‌باشد',
		ERR_NETWORK: 'خطایی در اتصال رخ داده است',
	}[status];

	toast.error(title, text);
}

export default errorHandler;
